<template>
  <div>
    <div class="customize-tag-wrap" :class="parent_component != 'note' ? 'small' : ''" v-if="permission.access">
      <div v-for="(tag, tag_index) in tags" :key="tag.tag_id" class="customize-tag" :class="[tag.tag_color, parent_component != 'note' ? 'small' : '']">
        <TruncateText :text="tag.tag_name || ''" :maxBytes="30" />
        <div class="customize-tag-times pointer" @click="deleteTag(tag.tag_id, tag_index)"><font-awesome-icon :icon="['fal', 'times']" /></div>
      </div>
      <div class="customize-tag-suggest">
        <div class="customize-tag-add" @click="activeEditTag()" v-if="!tag_input">
          <div class="flex-row" v-if="permission.access"><font-awesome-icon :icon="['fal', 'plus']" style="margin-right: 3px;" />タグを追加</div>
          <div style="margin: 0; width:80px" v-else><font-awesome-icon :icon="['fas', 'lock']" /></div>
        </div>
        <el-input
          placeholder="カスタマイズタグを入力"
          class="customize-tag-input"
          size="mini"
          v-model="new_tag"
          @input="suggestTag()"
          @focus="suggest_tag = true"
          @blur="suggest_on ? '' : (suggest_tag = false) & (tag_input = false) & (suggest_hover = -1)"
          @keydown.up.native="suggestHover('up', 'tag-box')"
          @keydown.down.native="suggestHover('down', 'tag-box')"
          @keypress.enter.native="suggest_hover > -1 ? addTag(tag_list[suggest_hover].tag_name) : addTag(new_tag)"
          id="autoFocus"
          v-else
        ></el-input>
        <div class="customize-tag-suggest-box-wrap" id="tag-box" :class="tag_list.length > 9 ? 'scroll' : ''" v-if="suggest_tag">
          <div
            v-for="(tag, index) in tag_list"
            :key="tag.tag_id"
            class="customize-tag-suggest-box"
            :class="suggest_hover == index ? 'hover' : ''"
            @click="addTag(tag.tag_name)"
            @mouseover="(suggest_on = true) && (suggest_hover = index)"
            @mouseleave="(suggest_on = false) && (suggest_hover = -1)"
            v-show="!tag.added"
          >
            <div class="customize-tag small" :class="tag.tag_color">{{ tag.tag_name }}</div>
            <div class="flex-space"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="customize-tag-add" @click="activeEditTag()">
        <div style="margin: 0; width:80px"><font-awesome-icon :icon="['fas', 'lock']" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import TruncateText from '../common/TruncateText.vue';

const root = process.env.VUE_APP_API;
const addTagAPI = root + "/api/note/add_tag";
const deleteTagAPI = root + "/api/note/delete_tag";
const loadTagAPI = root + "/api/note/load_tag";

export default {
  name: "customizeTag",
  components: {
    TruncateText,
  },
  props: {
    id: { type: String, required: true },
    sns_type: { type: String, required: true },
    tags: { type: Array, default: () => [] },
    parent_component: { type: String },
    influencer_index: { type: Number },
  },
  data() {
    return {
      drawer: false,
      tag_input: false,
      new_tag: "",
      suggest_tag: false,
      suggest_on: false,
      suggest_hover: -1,
      suggest_loading: false,
      tag_list: [],
      requestId: +new Date(),
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.note;
    },
  },
  mounted() {},
  methods: {
    openEditTagDrawer() {
      this.drawer = true;
      document.documentElement.style.overflow = "hidden";
    },
    closeEditTagDrawer() {
      this.drawer = false;
      document.documentElement.style.overflow = "auto";
    },
    activeEditTag() {
      if (this.permission.edit) {
        this.tag_input = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    loadTag() {
      this.suggest_loading = true;
      this.axios
        .get(loadTagAPI, {
          params: {
            token: this.token,
            sns_type: this.sns_type,
            id: this.id,
          },
        })
        .then((response) => {
          this.tag_list = response.data.tag_list;
          this.suggest_loading = false;
        })
        .catch(() => {});
    },
    suggestTag() {
      this.suggest_loading = true;
      this.suggest_tag = true;
      this.suggest_hover = -1;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.axios
        .get(loadTagAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            query: this.new_tag,
            sns_type: this.sns_type,
            id: this.id,
          },
        })
        .then((response) => {
          this.tag_list = response.data.tag_list;
          this.suggest_loading = false;
        })
        .catch(() => {});
    },
    addTag(tag_name) {
      var params = new URLSearchParams();
      params.append("sns_type", this.sns_type);
      params.append("id", this.id);
      params.append("token", this.token);
      params.append("tag_name", tag_name);
      this.axios.post(addTagAPI, params).then((response) => {
        this.new_tag = "";
        this.tag_input = false;
        this.suggest_tag = false;
        this.suggest_hover = -1;
        this.suggest_on = false;
        if(response.data.status === "NG") {
          this.$emit("updateTag", "add", this.new_tag, "", this.influencer_index);
          return;
        }
        this.$emit("updateTag", "add", "", response.data.new_tag, this.influencer_index);
        // this.tags.push(response.data.new_tag);
      });
    },
    deleteTag(tag_id, tag_index) {
      if (this.permission.edit) {
        var params = new URLSearchParams();
        params.append("sns_type", this.sns_type);
        params.append("id", this.id);
        params.append("token", this.token);
        params.append("tag_id", tag_id);
        params.append("delete_type", "influencer");
        this.axios
          .post(deleteTagAPI, params)
          .then(() => {
            this.$emit("updateTag", "delete", tag_index, "", this.influencer_index);
          })
          .catch(() => {});
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    suggestHover(type, position) {
      if (type == "up") {
        if (this.suggest_hover == -1) this.suggest_hover += 0;
        else this.suggest_hover -= 1;
      } else if (type == "down") {
        if (this.suggest_hover == this.tag_list.length - 1) this.suggest_hover += 0;
        else this.suggest_hover += 1;
      }
      var suggest_position = 30;
      var target = document.getElementById(position);
      target.scrollTop = (this.suggest_hover - 5) * suggest_position;
    },
    updateReactive(type, tag_id, value) {
      if (type == "delete") {
        for (var i = 0; i < this.tags.length; i++) {
          if (this.tags[i].tag_id == tag_id) this.tags.splice(i, 1);
        }
      }
      if (type == "name") {
        for (i = 0; i < this.tags.length; i++) {
          if (this.tags[i].tag_id == tag_id) this.tags[i].tag_name = value;
        }
      }
      if (type == "color") {
        for (i = 0; i < this.tags.length; i++) {
          if (this.tags[i].tag_id == tag_id) this.tags[i].tag_color = value;
        }
      }
      this.loadTag();
    },
  },
  watch: {
    tag_input() {
      if (this.tag_input == true) {
        this.loadTag();
        setTimeout(() => {
          document.getElementById("autoFocus").focus();
        }, 100);
      }
    },
  },
};
</script>
